import {PartnerLedger} from "./partner-ledger.model";

export class PartnerLedgerSummary {

    partnerId: number;
    partnerName: string;
    partnerType: string;
    totalRowCount: number;
    totalDebit: number;
    totalCredit: number;
    totalBalance: number;
    partnerLedgers: PartnerLedger[] = [];
    currencyCode: string;

    // New properties for per-partner filtering and balances
    filterDateRange: Date[] | undefined;
    openingBalance: number = 0;
    closingBalance: number = 0;
}